import axios from '../utils/axios';

export interface Route {
  id: string;
  name?: string;
  description?: string;
  route_category?: number;
  team_id?: string;
  created_at?: string;
  edit_ts?: string;
  lap_length?: number;
  bend_radius?: number;
  banking_angle?: number;
}

export interface CreateRouteData {
  description: string;
  route_category: number;
  lap_length: number;
  bend_radius: number;
  banking_angle: number;
}

export async function getRoutes(queryString: string = ''): Promise<Route[]> {
  const suffix = queryString ? `?${queryString}` : '';
  return axios.get(`/routes${suffix}`).then((res) => res?.data ?? []);
}

export async function createRoute(data: CreateRouteData): Promise<Route> {
  return axios.post('/routes', data).then((res) => res?.data);
}
